import React, { useState, useEffect } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  TypographyLarge,
  TypographyNormal,
} from "../../../../components/customComponent";
import { useDispatch, useSelector } from "react-redux";
import { linkAnnouncement } from "../../../store/actions/bplrt/equipmentAction";
import { red } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import SelectEquipAnnouncemet from "./SelectEquipAnnouncemet";
import {
  AdsScheduleIcon,
  AnnouncementPurpleIcon,
  CommandScheduleIcon,
  ContentScheduleIcon,
} from "../../../../icons";
import { isEmpty } from "lodash";
import ViewDetailSchedule from "../../../../components/viewDetails/schedule/ViewDetailSchedule";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const LinkAnnouncement = () => {
  const dispatch = useDispatch();
  const { breakdownAnnouncement, loadingAnnouncement: loading } = useSelector(
    (state) => state.bplrtEquip
  );

  const { t } = useTranslation("bplrtEquipment");

  const [open, setOpen] = useState(false);
  const [select, setSelect] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectItem = (val) => {
    setSelect(val);
  };

  const handleSubmit = () => {
    const payload = { schedules: select };
    dispatch(linkAnnouncement(payload));
    handleClose();
  };

  useEffect(() => {
    if (open) {
      setSelect(breakdownAnnouncement);
    }
  }, [open, breakdownAnnouncement]);

  return (
    <>
      {Object.keys(breakdownAnnouncement).length !== 0 ? (
        <>
          <Button
            startIcon={
              <CheckCircleIcon
                fontSize="medium"
                sx={{
                  color: breakdownAnnouncement.isActive
                    ? "rgba(0, 0, 0, 0.26)"
                    : "#1C4ED8",
                }}
              />
            }
            variant="outlined"
            {...(breakdownAnnouncement.isActive
              ? { disabled: true }
              : { disabled: false, onClick: handleOpen })}
          >
            {t("announcementLinkedBtn")}
          </Button>
        </>
      ) : (
        <>
          <Button
            onClick={handleOpen}
            startIcon={<ErrorIcon fontSize="medium" sx={{ color: red[600] }} />}
            variant="outlined"
            color="error"
          >
            {t("announcementNotLinkedBtn")}
          </Button>
        </>
      )}

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {t("linkAnnouncementDialogTitle")}
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="small" color="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <TypographyLarge>{"Selected announcements :"}</TypographyLarge>
            <Box
              sx={{
                border: "1px solid #e0e0e0", // light gray border
                borderRadius: 2,
                my: 1,
              }}
            >
              {isEmpty(select) && (
                <Alert severity="info">No announcements selected</Alert>
              )}
              {select.map((schedule) => (
                <ScheduleItem key={schedule?.id} schedule={schedule} />
              ))}
            </Box>
          </Box>
          <SelectEquipAnnouncemet
            disabled={loading}
            items={select}
            handleSelectedItem={handleSelectItem}
          />
        </DialogContent>

        <DialogActions>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            {t("cancelBtn")}
          </Button>

          <Button fullWidth variant="contained" onClick={handleSubmit}>
            {t("linkAnnouncementSubmitBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LinkAnnouncement;

const ScheduleItem = ({ schedule }) => {
  const [openDetail, setOpenDetail] = useState(false);

  const handleOpenDetail = () => {
    setOpenDetail(true);
  };

  const handleCloseDetail = () => {
    setOpenDetail(false);
  };
  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: 1, ml: 1 }}>
      <Box>
        {schedule.type === "ANNOUNCEMENT" ? (
          <AnnouncementPurpleIcon />
        ) : schedule.type === "ADVERTISEMENT" ? (
          <AdsScheduleIcon />
        ) : schedule.type.includes("CONTENT") ? (
          <ContentScheduleIcon />
        ) : (
          <CommandScheduleIcon />
        )}
      </Box>

      <Box
        sx={{
          ml: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TypographyNormal sx={{ fontWeight: 600 }}>
          {schedule.name}
        </TypographyNormal>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center", // vertically center
          justifyContent: "center", // horizontally center if needed
        }}
      >
        <IconButton
          onClick={handleOpenDetail}
          size="small"
          sx={{
            color: "primary.main", // default color
          }}
        >
          <InfoOutlinedIcon size="small" />
        </IconButton>
        <ViewDetailSchedule
          openDetail={openDetail}
          schedule={schedule}
          onClose={handleCloseDetail}
        />
      </Box>
    </Box>
  );
};
